/* eslint-disable no-unused-vars */

import appConfig from "../../../../app-config";
import ApiService from "../../api.service";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const SessionManagementService = {
  async removeSession(sessionId) {
    var payload = {
      SessionIds: [sessionId],
    };
    var url = "api/UserSession/RemoveBulk";
    return await ApiService.post(url, payload);
  },
  async removeSessions(sessionIds) {
    var payload = {
      SessionIds: sessionIds,
    };
    var url = "api/UserSession/RemoveBulk";
    return await ApiService.post(url, payload);
  },


  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { SessionManagementService };
